import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../../contexts/account/AccountContexts';
import { getAccount } from '../../services/account/AccountService';
import { useAuth } from '../../contexts/auth/AuthContext';
import { getProjects } from '../../services/projects/ProjectService';

const useAccountData = (projectId?: string) => {
  const { i18n } = useTranslation();
  const { accountResponse, setAccountResponse, projectResponse, setProjectResponse } = useAccount();
  const { isAuthenticated, logout } = useAuth(); // Dodaj logout
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    if (accountResponse && projectResponse) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const accountData = accountResponse || (await getAccount());
        const projectData = projectResponse || (await getProjects());

        if (!accountData) {
          logout();
          return;
        }

        if (!accountResponse) {
          await i18n.changeLanguage(accountData.language);
          setAccountResponse(accountData);
        }

        if (!projectResponse && projectData) {
          const force =
            !isNaN(Number(projectId)) &&
            accountData.isLimitedSuperAdmin &&
            !projectData.find((project) => project.id === Number(projectId));

          if (!force) {
            setProjectResponse(projectData);
          } else {
            const forcedProjectData = await getProjects(true);
            setProjectResponse(forcedProjectData);
          }
        }
      } catch (error) {
        console.error('Error fetching account or project data:', error);

        if ((error as any)?.response?.status === 401 || (error as any)?.response?.status === 403) {
          logout();
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    isAuthenticated,
    accountResponse,
    projectResponse,
    projectId,
    logout,
    i18n,
    setAccountResponse,
    setProjectResponse,
  ]);

  return loading;
};

export default useAccountData;
